import { useEffect, useState } from 'react';
import { latestUpdates, navEntries } from '@/mocks/homeData';

export default function TopBar() {
  const [tick, setTick] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTick((prev) => (prev + 1) % latestUpdates.length);
    }, 4200);
    return () => clearInterval(timer);
  }, []);

  const current = latestUpdates[tick];

  return (
    <div className="sticky top-0 z-50 w-full">
      <div id="updates" className="w-full bg-foreground-950 text-background-100">
        <div className="flex items-center gap-3 px-4 py-2 md:gap-5 md:px-8">
          <span className="flex shrink-0 items-center gap-2">
            <span className="animate-live-dot block h-1.5 w-1.5 rounded-full bg-primary-400" />
            <span className="font-label text-[11px] tracking-[0.2em] text-background-200">
              实时更新
            </span>
          </span>
          <span className="h-4 w-px shrink-0 bg-background-100/25" />
          <div className="min-w-0 flex-1 overflow-hidden">
            <p
              key={tick}
              className="animate-fade-up truncate font-label text-[13px] text-background-100/90"
            >
              <span className="mr-2 text-primary-300">{current.time}</span>
              {current.text}
            </p>
          </div>
          <a
            href="#blacklist"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap font-label text-[12px] text-background-200 transition-colors duration-200 hover:text-accent-300 md:flex"
          >
            全部更新
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-arrow-right-s-line text-base" />
            </span>
          </a>
        </div>
      </div>

      <header className="w-full border-b border-foreground-200/70 bg-background-50/95 backdrop-blur-md">
        <div className="flex items-center justify-between gap-4 px-4 py-3 md:px-8">
          <h1 className="shrink-0">
            <a href="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                17
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                  17黑料网
                </span>
                <span className="mt-0.5 font-label text-[10px] tracking-[0.18em] text-foreground-500">
                  避雷 · 盘点 · 参考
                </span>
              </span>
            </a>
          </h1>

          <nav className="hidden items-center gap-0.5 lg:flex">
            {navEntries.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors duration-200 hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#join"
              className="hidden items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-3 py-2 font-label text-sm text-primary-700 transition-colors duration-200 hover:bg-primary-100 md:flex"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-links-line text-base" />
              </span>
              快速入口
            </a>
            <a
              href="#join"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-2-line text-base" />
              </span>
              下载 App
            </a>
            <button
              type="button"
              aria-label="展开导航"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-200 text-foreground-800 transition-colors duration-200 hover:bg-background-100 lg:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-foreground-200/70 bg-background-50 px-4 py-3 lg:hidden">
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
              {navEntries.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-800 transition-colors duration-200 hover:bg-background-200"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        ) : null}
      </header>
    </div>
  );
}